module.exports = __webpack_public_path__ + "static/media/ProfessionalPositioning.03d2d6b6.svg";